import { atom } from "recoil"

export const AtomCurrentBadge4Name= atom({
    key:'ATOMBADGE4Name',
    default:''
})
  